/**
 * Escape string for safe use in inline JavaScript (onclick attributes)
 * Prevents syntax errors when strings contain quotes or special characters
 * @param {any} value - Value to escape
 * @returns {string} Escaped string safe for inline JS
 */
export const escapeJsString = value => {
    return String(value ?? '')
        .replace(/\\/g, '\\\\') // Escape backslash first
        .replace(/'/g, "\\'") // Escape single quotes
        .replace(/"/g, '\\"') // Escape double quotes
        .replace(/\r?\n/g, ' ') // Replace newlines with space
        .replace(/\r/g, ' '); // Replace carriage returns with space
};

/**
 * Escape HTML special characters to prevent XSS
 * @param {any} value - Value to escape
 * @returns {string} Escaped string safe for HTML
 */
export const escapeHtml = value => {
    const str = String(value ?? '');
    const map = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#x27;',
        '/': '&#x2F;'
    };
    return str.replace(/[&<>"'/]/g, char => map[char]);
};
